import React, { useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import { Icon } from "@com.mgmtp.a12.widgets/widgets-core/lib/icon/main/icon.view";
import { Toggle } from "@com.mgmtp.a12.widgets/widgets-core/lib/toggle";

import { PATH_TO_ASSIGNEE_GROUP } from "../../../utilities/variables/documentModelPaths";
import { ProcessMetadataContainingDocument } from "../../workflows/data/processMetadata";

import { showProcessAssignmentModal } from "../actions";
import { selectAssigneeFromDocument } from "../utils";

const assigneeButtonStyle = { border: "0 solid", textDecoration: "unset" };

export function AssignmentButton({
	document,
	activityId,
	readonly
}: {
	document: ProcessMetadataContainingDocument;
	activityId: string;
	readonly: boolean;
}): React.JSX.Element {
	const dispatch = useDispatch();
	const assignee = selectAssigneeFromDocument(
		document,
		PATH_TO_ASSIGNEE_GROUP.map(it => ({ ...it, index: 1 }))
	);

	const assigneeFieldStyle = useMemo(() => {
		return !assignee?.username
			? { color: "grey", fontStyle: "italic", fontWeight: "normal" }
			: { fontWeight: "normal" };
	}, [assignee]);

	const onClickHandler = useCallback(
		() => dispatch(showProcessAssignmentModal({ activityId })),
		[dispatch, activityId]
	);

	return (
		<div data-role="button">
			<Toggle>
				<Toggle.Item title="Zugewiesen an" style={assigneeFieldStyle} readOnly value="assignment">
					<Icon>account_circle</Icon>
					{assignee?.username
						? `${assignee.firstName} ${assignee.lastName}`
						: assignee?.fullName
							? assignee.fullName
							: "Nicht zugewiesen"}
				</Toggle.Item>
				{!readonly && (
					<Toggle.Item
						style={assigneeButtonStyle}
						onClick={onClickHandler}
						value="change-assignment"
						title="Zuweisung ändern"
					>
						Ändern
					</Toggle.Item>
				)}
			</Toggle>
		</div>
	);
}
